import { useEffect } from 'react'
import { StyledDSIImage } from './DSIImage.styled'
export const DSIImage = ({ mediaUploadId }) => {
  useEffect(() => {
    ;(window as any).ManheimFyusion.addViewer(mediaUploadId, 'fyuse_viewer')
  }, [mediaUploadId])

  return <StyledDSIImage id="fyuse_viewer"></StyledDSIImage>
}
